import React, { useState, useEffect, useRef } from 'react';
import { Html5QrcodeScanner, Html5Qrcode } from 'html5-qrcode';
import { BrowserMultiFormatReader } from '@zxing/library';
import api from '../services/api';
import AddThanNhanModalTinhAdmin from '../components/AddThanNhanModalTinhAdmin';
import './TinhThuMau.css';

// (Các hằng số giữ nguyên)
const TRANG_THAI_THU_MAU_OPTIONS_FORM = [
  { key: 'da_thu_mau', value: 'Đã thu mẫu', color: 'green' },
  { key: 'sai_thong_tin_da_thu', value: 'Sai TT - Đã thu', color: 'orange' },
  { key: 'sai_thong_tin_khong_thu', value: 'Sai TT - Không thu', color: 'orange' },
  { key: 'sai_dien', value: 'Sai diện', color: 'orange' },
  { key: 'khong_co_mat', value: 'Không có mặt', color: 'red' },
  { key: 'chua_thu', value: 'Hủy (Thu lại)', color: 'gray' },
];
const TRANG_THAI_THU_MAU_DB = [
  { key: 'chua_thu', value: 'Chưa thu', color: 'gray' },
  { key: 'da_thu_mau', value: 'Đã thu mẫu', color: 'green' },
  { key: 'sai_dien', value: 'Sai diện', color: 'orange' },
  { key: 'khong_co_mat', value: 'Không có mặt', color: 'red' },
  { key: 'khong_thu_mau', value: 'Không thu mẫu', color: 'red' },
];
const TRANG_THAI_RA_SOAT_OPTIONS = [
  { key: '', value: '-- TT Rà soát (Xã) --' },
  { key: 'chua_ra_soat', value: 'Chưa rà soát' },
  { key: 'xac_nhan', value: 'Xã xác nhận' },
  { key: 'khong_lien_lac', value: 'Xã báo: KLL' },
  { key: 'khong_ve_dung_hen', value: 'Xã báo: K về hẹn' },
  { key: 'khong_nhu_cau', value: 'Xã báo: K nhu cầu' },
  { key: 'qua_yeu', value: 'Xã báo: Quá yếu' },
  { key: 'da_thu_mau_truoc', value: 'Đã thu mẫu trước 01/7/2025' },
  { key: 'de_nghi_xoa', value: 'Đề nghị xóa' },
  { key: 'du_phong', value: 'Thân nhân dự phòng' },
  { key: 'tinh_xac_nhan', value: 'Tỉnh/Admin thêm' },
  { key: 'khac', value: 'Xã báo: Khác' },
];
const TINH_CHINH_XAC_OPTIONS = [
  { key: '', value: '-- Tính Chính xác --' },
  { key: 'dung', value: 'Đúng thông tin' },
  { key: 'sai', value: 'Sai thông tin' },
];
const TRANG_THAI_THU_MAU_FILTER = [
  { key: '', value: '-- TT Thu mẫu --' },
  { key: 'chua_thu', value: 'Chưa thu' },
  { key: 'da_thu_mau', value: 'Đã thu mẫu' },
  { key: 'sai_dien', value: 'Sai diện' },
  { key: 'khong_co_mat', value: 'Không có mặt' },
  { key: 'khong_thu_mau', value: 'Không thu mẫu (Do Sai TT)' },
];

function TinhThuMau() {
  
  // (Các state và hàm logic quét QR giữ nguyên y hệt)
  const [danhSach, setDanhSach] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [searchParams, setSearchParams] = useState({
    xa_id: '', ten_tn: '', cccd: '', trang_thai_rs: '', trang_thai_tm: '', tinh_chinh_xac: ''
  });
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [limit] = useState(50);
  const [xaPhuongList, setXaPhuongList] = useState([]);
  const [noteModal, setNoteModal] = useState({ open: false, thanNhanId: null, statusKey: '', ghi_chu: '' });
  const [isScanning, setIsScanning] = useState(false);
  const [torchOn, setTorchOn] = useState(false);
  const scannerRef = useRef(null);
  const zxingReader = useRef(new BrowserMultiFormatReader());
  const mutationObserverRef = useRef(null);
  const currentTrackRef = useRef(null);

  useEffect(() => {
    if (!isScanning) return;
    let scanner;
    let videoElement = null;
    const elementId = 'qr-reader';
    const onSuccess = (decodedText, decodedResult) => {
      handleQrSuccess(decodedText);
    };
    const onFailure = (error) => {
      if (error && error.name === 'NotFoundError') return;
    };
    const config = {
      fps: 15,
      qrbox: { width: 80, height: 80 },
      aspectRatio: 1,
      disableFlip: true,
      rememberLastUsedCamera: true,
      experimentalFeatures: {
        useBarCodeDetectorIfSupported: false
      },
      videoConstraints: {
        facingMode: { ideal: "environment" },
        width: { ideal: 1920 },
        height: { ideal: 1080 },
        focusMode: 'continuous',
        advanced: [{ zoom: 2.0 }]
      }
    };
    try {
      scanner = new Html5QrcodeScanner(elementId, config, false);
      scanner.render(onSuccess, onFailure);
      scannerRef.current = scanner;
    } catch (e) {
      console.error('Html5QrcodeScanner init error', e);
    }
    const adjustScanner = () => {
      const container = document.getElementById(elementId);
      if (!container) return;
      const video = container.querySelector('video');
      if (!video || video.readyState === 0) return;
      videoElement = video;
      const overlay = container.querySelector('.html5-qrcode-overlay, .qr-label'); 
      if (overlay) {
        overlay.style.pointerEvents = 'none';
      }
      setTimeout(() => {
        try {
          const stream = video.srcObject;
          if (stream) {
            const track = stream.getVideoTracks()[0];
            currentTrackRef.current = track;
            enableTorch(track, true);
          }
        } catch (e) {
        }
      }, 800);
      try {
        zxingReader.current.decodeFromVideoDevice(
          null,
          video,
          (result) => {
            if (result) {
              try {
                const text = result.getText ? result.getText() : result;
                handleQrSuccess(text);
              } catch (errInner) {
                console.warn('ZXing parse error', errInner);
              }
            }
          },
          {
            tryHarder: true
          }
        );
      } catch (err) {
        console.warn('ZXing fallback init failed', err);
      }
      if (mutationObserverRef.current) {
        mutationObserverRef.current.disconnect();
        mutationObserverRef.current = null;
      }
    };
    const mo = new MutationObserver(() => {
      adjustScanner();
    });
    mutationObserverRef.current = mo;
    const elToObserve = document.getElementById(elementId);
    if (elToObserve) {
      mo.observe(elToObserve, { childList: true, subtree: true });
      setTimeout(adjustScanner, 600);
    } else {
      setTimeout(() => {
        const el = document.getElementById(elementId);
        if (el) {
          mo.observe(el, { childList: true, subtree: true });
          setTimeout(adjustScanner, 600);
        }
      }, 500);
    }
    return () => {
      try {
        if (mutationObserverRef.current) {
          mutationObserverRef.current.disconnect();
          mutationObserverRef.current = null;
        }
        if (zxingReader.current) {
          zxingReader.current.reset();
        }
      } catch (e) {
        console.warn('Cleanup error', e);
      }
      try {
        if (scannerRef.current) {
          scannerRef.current.clear().catch(() => { /* ignore */ });
          scannerRef.current = null;
        }
      } catch (e) {
      }
      if (videoElement) {
        try {
          const tracks = videoElement.srcObject?.getTracks?.() || [];
          tracks.forEach(t => {
            try { t.stop(); } catch (e) {}
          });
        } catch (e) {}
      }
      const track = currentTrackRef.current;
      if (track) {
        try { track.stop(); } catch (e) {}
        currentTrackRef.current = null;
      }
    };
  }, [isScanning]);
  const enableTorch = async (track, on) => {
    try {
      const caps = track?.getCapabilities?.();
      if (caps?.torch) {
        await track.applyConstraints({ advanced: [{ torch: on }] });
        setTorchOn(on);
      } else {
        console.warn('Torch not supported');
      }
    } catch (err) {
      console.warn('Torch control error:', err);
    }
  };
  const toggleTorch = async () => {
    const track = currentTrackRef.current;
    if (!track) return;
    await enableTorch(track, !torchOn);
  };
  const handleQrSuccess = (text) => {
    try {
      if (!text || typeof text !== 'string') throw new Error('Kết quả QR không hợp lệ');
      let cccdMatch = text.match(/^(\d{12})/);
      if (!cccdMatch) {
        const any12 = text.match(/(\d{12})/);
        if (any12) {
          cccdMatch = any12;
        }
      }
      if (!cccdMatch) throw new Error('Không tìm thấy CCCD');
      const fullCCCD = cccdMatch[1];
      const cccd_short = fullCCCD.slice(9, 12);
      const parts = text.split('|');
      const ho_ten = (parts[2] || parts[1] || '').trim();
      const newParams = { ...searchParams, cccd: cccd_short, ten_tn: ho_ten };
      setSearchParams(newParams);
      setCurrentPage(1);
      fetchData(1, newParams);
    } catch (e) {
      setError(e.message || 'Lỗi khi đọc QR');
    } finally {
      setIsScanning(false);
      const track = currentTrackRef.current;
      if (track) {
        try { enableTorch(track, false); } catch (e) {}
      }
    }
  };
  useEffect(() => {
    fetchData(1, searchParams);
    fetchXaPhuong();
  }, []);
  const fetchData = async (page, filters) => {
    setLoading(true); setError('');
    try {
      const params = new URLSearchParams(filters);
      params.append('page', page);
      params.append('limit', limit);
      const res = await api.get(`/tinh/danh-sach?${params.toString()}`);
      setDanhSach(res.data.data);
      setTotalPages(res.data.totalPages);
      setCurrentPage(res.data.currentPage);
    } catch (err) {
      setError('Không thể tải danh sách.');
      setDanhSach([]);
      setTotalPages(0);
    } finally {
      setLoading(false);
    }
  };
  const fetchXaPhuong = async () => {
    try {
      const res = await api.get('/data/xaphuong');
      setXaPhuongList(res.data);
    } catch (err) { console.error(err); }
  };
  const handleFilterChange = (e) => setSearchParams(p => ({ ...p, [e.target.name]: e.target.value }));
  const handleSearchSubmit = (e) => { e.preventDefault(); setCurrentPage(1); fetchData(1, searchParams); };
  const handlePageChange = (p) => { if (p >= 1 && p <= totalPages) fetchData(p, searchParams); };
  const handleUpdateStatus = async (id, status) => {
    if (status.startsWith('sai_thong_tin')) {
      const tn = danhSach.find(t => t.id === id);
      setNoteModal({ open: true, thanNhanId: id, statusKey: status, ghi_chu: tn.ghi_chu_tinh || '' });
      return;
    }
    const tn = danhSach.find(t => t.id === id);
    const statusText = TRANG_THAI_THU_MAU_OPTIONS_FORM.find(o => o.key === status)?.value || status;
    if (!window.confirm(`Cập nhật [${tn.ho_ten}] → [${statusText}]?`)) return;
    try {
      await api.put(`/tinh/thu-mau/${id}`, { trang_thai_thu_mau: status, ghi_chu_tinh: null });
      fetchData(currentPage, searchParams);
    } catch (err) { alert('Lỗi cập nhật'); }
  };
  const handleNoteSubmit = async () => {
    if (!noteModal.ghi_chu.trim()) return setError('Vui lòng nhập ghi chú');
    try {
      await api.put(`/tinh/thu-mau/${noteModal.thanNhanId}`, {
        trang_thai_thu_mau: noteModal.statusKey,
        ghi_chu_tinh: noteModal.ghi_chu
      });
      setNoteModal({ open: false, thanNhanId: null, statusKey: '', ghi_chu: '' });
      fetchData(currentPage, searchParams);
    } catch (err) { setError('Lỗi lưu ghi chú'); }
  };
  const handleAddModalSave = () => {
    setIsAddModalOpen(false);
    const empty = { xa_id: '', ten_tn: '', cccd: '', trang_thai_rs: '', trang_thai_tm: '', tinh_chinh_xac: '' };
    setSearchParams(empty);
    fetchData(1, empty);
  };
  
  if (loading && !isScanning) return <p>Đang tải danh sách...</p>;

  return (
    <div className="tinh-thu-mau-container">

      {/* BỘ LỌC (Giữ nguyên) */}
      {!isScanning && (
        <>
          <h2>Danh sách Thu mẫu (Cán bộ Tỉnh/Admin)</h2>
          <form onSubmit={handleSearchSubmit} className="filter-form">
            <h4>Bộ lọc / Tìm kiếm</h4>
            <div className="filter-grid">
              <div><label>Lọc theo xã: </label>
                <select name="xa_id" value={searchParams.xa_id} onChange={handleFilterChange}>
                  <option value="">-- Tất cả {xaPhuongList.length} xã --</option>
                  {xaPhuongList.map(xa => <option key={xa.id} value={xa.id}>{xa.ten_xa}</option>)}
                </select>
              </div>
              <div><label>Tên:</label><input type="text" name="ten_tn" value={searchParams.ten_tn} onChange={handleFilterChange} /></div>
              <div><label>3 số cuối CCCD:</label><input type="text" name="cccd" value={searchParams.cccd} onChange={handleFilterChange} maxLength={3} /></div>
              <div><label>TT Rà soát:</label>
                <select name="trang_thai_rs" value={searchParams.trang_thai_rs} onChange={handleFilterChange}>
                  {TRANG_THAI_RA_SOAT_OPTIONS.map(o => <option key={o.key} value={o.key}>{o.value}</option>)}
                </select>
              </div>
              <div><label>TT Thu mẫu:</label>
                <select name="trang_thai_tm" value={searchParams.trang_thai_tm} onChange={handleFilterChange}>
                  {TRANG_THAI_THU_MAU_FILTER.map(o => <option key={o.key} value={o.key}>{o.value}</option>)}
                </select>
              </div>
              <div><label>Tính chính xác:</label>
                <select name="tinh_chinh_xac" value={searchParams.tinh_chinh_xac} onChange={handleFilterChange}>
                  {TINH_CHINH_XAC_OPTIONS.map(o => <option key={o.key} value={o.key}>{o.value}</option>)}
                </select>
              </div>
            </div>
            <div className="filter-actions">
              <button type="submit" className="btn btn-primary">Tìm kiếm</button>
              <button type="button" onClick={() => { const e = { xa_id: '', ten_tn: '', cccd: '', trang_thai_rs: '', trang_thai_tm: '', tinh_chinh_xac: '' }; setSearchParams(e); fetchData(1, e); }} className="btn btn-secondary">Xóa lọc</button>
              <button type="button" onClick={() => setIsScanning(true)} className="btn btn-success">Quét QR CCCD</button>
              <button type="button" onClick={() => setIsAddModalOpen(true)} className="btn btn-purple">+ Thêm mới</button>
            </div>
          </form>
        </>
      )}

      {/* GIAO DIỆN QUÉT QR (Giữ nguyên) */}
      {isScanning && (
        <div id="qr-reader-container">
          <div id="qr-reader" style={{ width: '100%', height: '480px' }}></div>
          <p className="qr-hint">
            <strong>Đưa chip cách camera 6–10cm</strong><br />
            Giữ yên 2 giây. Khung quét sẽ tự thu nhỏ.
          </p>
          <div style={{ marginTop: '10px', display: 'flex', gap: '10px', justifyContent: 'center' }}>
            <button onClick={toggleTorch} className="btn btn-warning">
              {torchOn ? '🔦 Tắt đèn' : '💡 Bật đèn'}
            </button>
            <button onClick={() => setIsScanning(false)} className="btn btn-danger">Tắt Camera</button>
          </div>
        </div>
      )}

      {/* BẢNG DỮ LIỆU */}
      {!isScanning && (
        <>
          {error && <p style={{ color: 'red' }}>Lỗi: {error}</p>}
          {totalPages > 0 && (
            <div className="pagination">
              <button onClick={() => handlePageChange(1)} disabled={currentPage === 1}>Trang đầu</button>
              <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Trang trước</button>
              <span>Trang <strong>{currentPage}</strong> / {totalPages}</span>
              <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Trang sau</button>
              <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>Trang cuối</button>
            </div>
          )}
          <div className="table-wrapper">
            <table className="responsive-table">
              <thead>
                <tr>
                  <th>Họ tên</th>
                  
                  {/* (*** SỬA 1 ***) */}
                  <th>Năm sinh</th>
                  
                  <th>CCCD (3 số)</th>
                  <th>Xã</th>
                  <th>TT Rà soát (Xã)</th>
                  <th>Tính chính xác</th>
                  <th>Ghi chú (Tỉnh)</th>
                  <th>Trạng thái Thu mẫu</th>
                  <th>Ngày thu mẫu</th>
                  <th>Hành động (Tỉnh)</th>
                </tr>
              </thead>
              <tbody>
                {danhSach.length === 0 ? (
                  <tr><td colSpan="10" className="no-data">Không có dữ liệu</td></tr>
                ) : (
                  danhSach.map(tn => (
                    <tr key={tn.id} style={{
                      background: tn.tinh_chinh_xac === 'sai' ? '#fff8e1' :
                                 tn.trang_thai_thu_mau === 'da_thu_mau' ? '#e8f5e9' : 'white'
                    }}>
                      <td data-label="Họ tên">{tn.ho_ten}</td>
                      
                      {/* (*** SỬA 2 ***) */}
                      <td data-label="Năm sinh">{tn.nam_sinh}</td>
                      
                      <td data-label="CCCD (3 số)">{tn.cccd}</td>
                      <td data-label="Xã">{tn.ten_xa}</td>
                      <td data-label="TT Rà soát (Xã)">
                        {TRANG_THAI_RA_SOAT_OPTIONS.find(o => o.key === tn.trang_thai_ra_soat)?.value || tn.trang_thai_ra_soat}
                      </td>
                      <td data-label="Tính chính xác" style={{ color: tn.tinh_chinh_xac === 'sai' ? 'red' : 'green', fontWeight: 'bold' }}>
                        {tn.tinh_chinh_xac === 'sai' ? 'Sai' : 'Đúng'}
                      </td>
                      <td data-label="Ghi chú (Tỉnh)" style={{ fontStyle: 'italic', color: 'red' }}>{tn.ghi_chu_tinh}</td>
                      <td data-label="Trạng thái Thu mẫu" style={{
                        color: TRANG_THAI_THU_MAU_DB.find(o => o.key === tn.trang_thai_thu_mau)?.color,
                        fontWeight: 'bold'
                      }}>
                        {TRANG_THAI_THU_MAU_DB.find(o => o.key === tn.trang_thai_thu_mau)?.value}
                      </td>
                      <td data-label="Ngày thu mẫu">
                        {(tn.trang_thai_thu_mau !== 'chua_thu' && tn.ngay_cap_nhat_thu_mau)
                          ? new Date(tn.ngay_cap_nhat_thu_mau).toLocaleString('vi-VN') : ''}
                      </td>
                      <td data-label="Hành động (Tỉnh)">
                        {tn.trang_thai_thu_mau === 'da_thu_mau' ? (
                          <button
                            onClick={() => handleUpdateStatus(tn.id, 'chua_thu')}
                            className="btn-action"
                            style={{ background: 'gray', color: 'white', width: '100%' }}
                          >
                            Hủy (Xác nhận lại)
                          </button>
                        ) : tn.tinh_chinh_xac === 'dung' ? (
                          <div className="action-buttons-cell">
                            <button onClick={() => handleUpdateStatus(tn.id, 'da_thu_mau')} style={{background:'green',color:'white'}}>Đã thu</button>
                            <button onClick={() => handleUpdateStatus(tn.id, 'sai_thong_tin_da_thu')} style={{background:'orange'}}>Sai TT (Đã thu)</button>
                            <button onClick={() => handleUpdateStatus(tn.id, 'sai_thong_tin_khong_thu')} style={{background:'orange'}}>Sai TT (Không thu)</button>
                            <button onClick={() => handleUpdateStatus(tn.id, 'sai_dien')} style={{background:'orange'}}>Sai diện</button>
                            <button onClick={() => handleUpdateStatus(tn.id, 'khong_co_mat')} style={{background:'red',color:'white'}}>Vắng</button>
                          </div>
                        ) : (
                          <button onClick={() => handleUpdateStatus(tn.id, 'chua_thu')} style={{background:'gray',color:'white'}}>Hủy</button>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          {totalPages > 0 && (
            <div className="pagination">
              <button onClick={() => handlePageChange(1)} disabled={currentPage === 1}>Trang đầu</button>
              <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Trang trước</button>
              <span>Trang <strong>{currentPage}</strong> / {totalPages}</span>
              <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Trang sau</button>
              <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>Trang cuối</button>
            </div>
          )}
        </>
      )}

      {/* MODAL (Giữ nguyên) */}
      {isAddModalOpen && <AddThanNhanModalTinhAdmin onClose={() => setIsAddModalOpen(false)} onSave={handleAddModalSave} />}
      {noteModal.open && (
        <div className="modal-backdrop">
          <div className="modal-content">
            <h4>Ghi chú (Bắt buộc)</h4>
            <p>Nhập lý do cho "Sai thông tin":</p>
            <textarea value={noteModal.ghi_chu} onChange={e => setNoteModal(p => ({ ...p, ghi_chu: e.target.value }))} />
            {error && <p className="modal-error">{error}</p>}
            <div className="modal-actions">
              <button onClick={() => { setNoteModal({ open: false, thanNhanId: null, statusKey: '', ghi_chu: '' }); setError(''); }} className="btn btn-secondary">Hủy</button>
              <button onClick={handleNoteSubmit} className="btn btn-primary">Lưu</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default TinhThuMau;